<template>
  <v-form ref="filtersForm">
    <v-row align="center" justify="start">
      <v-col cols="12" sm="6" md="3" lg="3" xl="2">
        <SimpleDatePicker
          label="Start Date"
          :value="startDate"
          :isRequired="true"
          @selected-date-change="(newValue) => this.startDate = newValue"
        ></SimpleDatePicker>
      </v-col>
      <v-col cols="12" sm="6" md="3" lg="3" xl="2">
        <SimpleDatePicker
          label="End Date"
          :value="endDate"
          :isRequired="true"
          :min-date="startDate"
          :min-date-enable="true"
          @selected-date-change="(newValue) => this.endDate = newValue"
        ></SimpleDatePicker>
      </v-col>
      <v-col cols="12" sm="6" md="3" lg="3" xl="2">
        <ClientsDropDownList
          :id="clientId"
          :clearable="true"
          :isRequired="true"
          @clientIdChange="handleClientIdChange">
        </ClientsDropDownList>
      </v-col>
      <v-col cols="12" sm="6" md="3" lg="3" xl="2">
        <v-select
          v-model="userId"
          :items="consultantsList"
          item-text="consultantName"
          item-value="id"
          label="Consultant"
          :rules="[Required('Consultant')]"
          :disabled="!clientId"
          outlined
          clearable
          @change="handleUserIdChange"
        ></v-select>
      </v-col>
      <v-col cols="12" sm="6" md="5" lg="4" xl="3">
        <v-select
          v-model="assignmentId"
          :items="filteredAssignments"
          item-text="name"
          item-value="id"
          label="Job Title"
          :rules="[Required('Job Title')]"
          outlined
          clearable
          :disabled="!clientId && !userId"
        ></v-select>
      </v-col>
    </v-row>
    <v-row justify="end">
      <v-col cols="12" sm="6">
        <FilterButtons
          @search="handleSearchClick"
          @clear="handleClearClick"
        ></FilterButtons>
      </v-col>
    </v-row>
    <FilterButtonsSmall
      @search="handleSearchClick"
      @clear="handleClearClick"
    ></FilterButtonsSmall>
  </v-form>
</template>

<script>
import { UsersDropDownList } from '@/components/users'
import { ClientsDropDownList } from '@/components/clients'
import { FilterButtons, FilterButtonsSmall } from '@/components/buttons'
import { mapFields } from '@/vueHelpers/vuex'
import { mapActions } from 'vuex'
import { CONSULTANT } from '@/lib/constants/securityRoles'
import { STAFF, CONSULTANTS } from '@/lib/constants/reportTypes'
import { SimpleDatePicker } from '@/components/shared/datePickers'
import Required from '@/lib/formValidations/required'
import { formatDate } from '@/lib/display'

export default {
  components: {
    UsersDropDownList,
    ClientsDropDownList,
    FilterButtons,
    FilterButtonsSmall,
    SimpleDatePicker
  },
  data () {
    return {
      CONSULTANT,
      STAFF,
      CONSULTANTS,
      clientAssignments: [],
      consultantsList: [],
      filteredAssignments: []
    }
  },
  computed: {
    ...mapFields('timeCardReportFilters',
      [
        'reportFilterType',
        'startDate',
        'endDate',
        'clientId',
        'userId',
        'assignmentId'
      ])
  },
  methods: {
    Required,
    formatDate,
    ...mapActions('timeCardReportFilters', ['clearFilters']),
    ...mapActions('timeCardReport', ['getTimeCardReportWithFilters', 'clearTimeCardReport']),
    ...mapActions('assignments', ['getAssignments']),
    handleClientIdChange (newValue) {
      this.clientId = newValue
      if (!newValue) {
        this.userId = null
        this.assignmentId = null
      }
      return this.getAssignments({ clientId: newValue }).then((assignments) => {
        this.clientAssignments = assignments
        this.consultantsList = assignments.map((assignment) => { return { id: assignment.userId, consultantName: assignment.userFullName } })
        this.consultantsList = [...new Map(this.consultantsList.map(v => [v.id, v])).values()]
        if (this.consultantsList.length === 1) {
          this.handleUserIdChange(this.consultantsList[0].id)
        }
      })
    },
    handleUserIdChange (newValue) {
      this.userId = newValue
      if (!newValue) {
        this.assignmentId = null
      }
      this.filteredAssignments =
      this.clientAssignments
        .filter((assignment) => assignment.userId === newValue)
        .map((assignment) => { return { id: assignment.id, name: assignment.jobTitle + ' - ' + this.formatDate(assignment.startAt) } })
      if (this.filteredAssignments.length === 1) {
        this.assignmentId = this.filteredAssignments[0].id
      }
    },
    handleSearchClick () {
      if (this.$refs.filtersForm.validate()) {
        this.getTimeCardReportWithFilters().then(() => {
          this.$emit('searchTimeCardEntries')
        })
      }
    },
    handleClearClick () {
      this.clearFilters()
      this.clearTimeCardReport()
      this.$emit('clearFilters')
    }
  }
}
</script>
